import { createStorageWrapper } from './storage';

const moduleWindow = (typeof window !== 'undefined' && window) || null;

/**
 * クライアント用 : local storage用のラッパーモジュール
 */
interface ILocalStorage {
  get: <T>(key: string, version: number, defaultValue?: T) => T | undefined;
  set: <T>(key: string, version: number, value: T) => void;
  remove: (key: string) => void;
}

interface LocalStorageItem<T> {
  version: number;
  value: T;
}

const storageWrapper = createStorageWrapper(() => moduleWindow?.localStorage, {
  serialize: <T>(value: T) => {
    const serialized = JSON.stringify(value);
    if (serialized === undefined) {
      throw new Error('Failed to serialize localStorage value');
    }
    return serialized;
  },
  deserialize: <T>(value: string) => JSON.parse(value) as T
});

export const localStorage: ILocalStorage = (() => {
  return {
    get: <T>(key: string, version: number, defaultValue?: T): T | undefined => {
      const item = storageWrapper.get<LocalStorageItem<T>>(key);
      if (!item?.version || item.version < version) {
        //  | versionがない | versionが古い
        // 上記に当てはまる場合、デフォルト値を返す
        return defaultValue;
      }
      return item.value;
    },
    set: <T>(key: string, version: number, value: T) => {
      storageWrapper.set<LocalStorageItem<T>>(key, { version, value });
    },
    remove: (key: string) => {
      storageWrapper.remove(key);
    }
  };
})();
